export function getGradeSettingsFromFirstSeniorGrade(firstSeniorGrade) {
    let gradeSettings = [
        { number: 0, level: 'junior', multiplier: 2, russianEquivalent: 0 },
        { number: 1, level: 'junior', multiplier: 2, russianEquivalent: 1 },
        { number: 2, level: 'junior', multiplier: 2, russianEquivalent: 2 },
        { number: 3, level: 'junior', multiplier: 2, russianEquivalent: 3 },
        { number: 4, level: 'junior', multiplier: 2, russianEquivalent: 4 },
        { number: 5, level: 'junior', multiplier: 2, russianEquivalent: 5 },
        { number: 6, level: 'junior', multiplier: 2, russianEquivalent: 6 },
        { number: 7, level: 'junior', multiplier: 1.5, russianEquivalent: 7 },
        { number: 8, level: 'junior', multiplier: 1.333333, russianEquivalent: 8 },
        { number: 9, level: 'junior', multiplier: 1, russianEquivalent: 9 },
        { number: 10, level: 'senior', multiplier: 1.25, russianEquivalent: 10 },
        { number: 11, level: 'senior', multiplier: 1, russianEquivalent: 11 },
        { number: 12, level: 'senior', multiplier: 1, russianEquivalent: 12 },
        { number: 13, level: 'senior', multiplier: 1, russianEquivalent: 13 },
    ];

    if (firstSeniorGrade - 10 > 0) {
        for (let k = 0; k < firstSeniorGrade - 10; k++) {
            for (let i = gradeSettings.length - 1; i > 0; i--) {
                gradeSettings[i].level = gradeSettings[i - 1].level;
                gradeSettings[i].multiplier = gradeSettings[i - 1].multiplier;
                gradeSettings[i].russianEquivalent = gradeSettings[i - 1].russianEquivalent;
            }
        }
    } else {
        for (let k = 0; k < 10 - firstSeniorGrade; k++) {
            for (let i = 0; i < gradeSettings.length - 1; i++) {
                gradeSettings[i].level = gradeSettings[i + 1].level;
                gradeSettings[i].multiplier = gradeSettings[i + 1].multiplier;
                gradeSettings[i].russianEquivalent = gradeSettings[i + 1].russianEquivalent;
            }
        }
    }

    return gradeSettings;
}



// WEBPACK FOOTER //
// ./src/utils/gradeSettings.js